const actionTypes = {
  SET_MESSAGE_TYPE: 'setMessageType',
  SET_PAGE_MESSAGES: 'setPageMessages',
  ADD_PAGE_MESSAGE: 'addPageMessage',
  DELETE_ONE_PAGE_MESSAGE: 'deleteOnePageMessage',
  CLEAR_PAGE_MESSAGE: 'clearPageMessage',
  SET_BALLON_MESSAGE_LAST_TYPE: 'setBallonMessageLastType',
}

export default actionTypes
